<template lang="pug">
#AddInventoryForm
  div(style="display: flex; justify-content: end;")
    b-button.mb-3(variant="button" :href="fileUrl" download)
      b-icon.mr-1(icon="cloud-download" variant="ligth")
      | Descargar Plantilla
  .container-list
    b-card(border-variant="light")
      .d-flex.justify-content-between.mb-3.align-items-end
        h5.title {{title}}
        b-button(variant="button" v-b-modal.file-modal)
          b-icon.mr-1(icon="file-earmark-arrow-up-fill" variant="ligth")
          |  Carga Masiva
      b-modal#file-modal(title="Seleccionar archivo" hide-footer)
        b-form-file(
          v-model="file"
          accept=".xlsx, .xls, .csv"
          placeholder="Seleccionar archivo"
          drop-placeholder="Arrastre el archivo aquí"
          browse-text="Buscar"
        )
        .d-flex.justify-content-end.mt-5
          b-button(variant="button" @click="handleFileUpload") Cargar
      b-table(
        :items="tableItems",
        :fields="computedFields",
        :busy="loading"
      )
        template(#table-busy)
          .loader-container
            Loader
        
        template(#cell(part_number)='value')
          vue-typeahead-bootstrap(
            v-model="tableItems[value.index].part_number"
            @input="handleInput(value.index, $event)"
            :data="data"
            :serializer="p => p.part_number"
            placeholder="Ingresar Código"
            @hit="(item) => handleHit(item, value.index)"
            :state="$v.$dirty? !$v.tableItems.$each[value.index].part_number.$invalid : null"
            :disabled="Boolean(tableItems[value.index].id)"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.tableItems.$each[value.index].part_number.required")
              | Campo requerido
        template(#cell(quantity)='value')
          b-form-group(:invalid-feedback="getQuantityFeedback(value.index)")
            b-form-input(
              v-model="value.item.quantity"
              type="number" :min="isRebaja ? 0 : 1" :state="$v.$dirty? !$v.tableItems.$each[value.index].quantity.$invalid : null",
              :disabled="!(tableItems[value.index].id)"
            )
        template(#cell(existingQuantity)='value', v-if="existingQuantityAttribute")
          b-form-input(v-model="value.item[existingQuantityAttribute]" disabled)
        template(#cell(real_location)='value')
          b-form-input(v-model="value.item.real_location" disabled)
        template(#cell(description)='value')
          b-form-input(v-model="value.item.description" disabled)
        template(#cell(delete)='value')
          b-button(variant="link" @click="handleDeleteRow")
            b-icon.mr-1(icon="trash-fill" variant="danger")

      b-modal#confirmation-modal(:title="confirmationTitle" hide-footer centered size="lg")
        .confirmation-content
          .text-center.mb-3
            p.mb-0 Vas a rebajar los siguientes repuestos.
            p Por favor confirma que son correctos.
          h5.mb-3
            b-icon.mr-2(icon="tools")
            | Repuestos
          b-table-simple(hover responsive)
            b-thead
              b-tr
                b-th Part Number
                b-th.text-center Cant. Actual
                b-th.text-center Cant. a Rebajar
                b-th.text-center(style="color: #007bff;") Cant. Total
            b-tbody
              b-tr(v-for="(item, index) in summaryItems" :key="index")
                b-td {{ item.part_number }}
                b-td.text-center {{ item.existingQuantity }}
                b-td.text-center {{ item.quantity }}
                b-td.text-center.font-weight-bold {{ item.existingQuantity - item.quantity }}
          .d-flex.justify-content-between.mt-4
            b-button(variant="light" @click="$bvModal.hide('confirmation-modal')") Cancelar
            b-button(variant="warning" @click="executeSave") Confirmar

      .d-flex.justify-content-between(v-if="$route.params.tipo !== 'rtv'")
        b-button(variant="link" @click="handleAddRow")
          b-icon.mr-1(icon="plus-square-fill" )
          |  Agregar Pieza
        b-button(variant="link" @click="handleDeleteAll" v-if="tableItems.length > 0")
          div(style="color: var(--danger)") Eliminar todas las piezas
      .d-flex.flex-row-reverse
        b-button.px-5.mt-5(variant="estado-green" @click="handleSaveClick" v-if="tableItems.length > 0" :disabled="loading") Guardar
</template>
<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import { mapActions, mapGetters } from 'vuex'
import { required, minValue } from 'vuelidate/lib/validators'
import Loader from '../UI/Loader.vue'

const basePath = process.env.VUE_APP_SERVER_BASE || 'https://center.samtek.cl'

export default {
  name: 'AddInventoryForm',
  components: {
    VueTypeaheadBootstrap,
    Loader,
  },
  data() {
    return {
      fields: [
        { key: 'part_number', label: 'Código de la Pieza' },
        { key: 'quantity', label: 'Cantidad' },
        { key: 'existingQuantity', label: 'Cantidad existente' },
        { key: 'real_location', label: 'Ubicación Real' },
        { key: 'description', label: 'Descripción' },
        { key: 'delete', label: '' },
      ],
      tableItems: [],
      search: '',
      data: [],
      index: null,
      file: null,
      loading: false,
      fileUrl: `${basePath}/plantilla_mantenedor.xlsx`,
      summaryFields: [
        { key: 'part_number', label: 'Código de la Pieza' },
        { key: 'existingQuantity', label: 'Cantidad Actual' },
        { key: 'quantity', label: 'Cantidad a Mover' },
      ],
    }
  },
  validations() {
    if (this.isRebaja) {
      return {
        tableItems: {
          $each: {
            part_number: {
              required,
            },
            quantity: {
              minValue: minValue(this.isManualDrop ? 1 : 0),
              validStock: (value, item) => {
                if (!this.isManualDrop) return true
                if (!value) return true
                const existing = item[this.existingQuantityAttribute]
                if (existing === undefined || existing === null) return true
                return parseInt(value, 10) <= existing
              },
            },
          },
        },
      }
    }
    return {
      tableItems: {
        $each: {
          part_number: {
            required,
          },
          quantity: {
            required,
            minValue: minValue(1),
          },
        },
      },
    }
  },
  methods: {
    ...mapActions('Diagnosticos', ['searchByPartNumber', 'searchPartsByState']),
    ...mapActions('Warehouse', ['saveInventory', 'saveInventoryExcel']),
    getQuantityFeedback(index) {
      const field = this.$v.tableItems.$each[index].quantity
      if (field.validStock === false) return 'Excede el stock disponible'
      if (!this.isRebaja && !field.required) return 'Campo requerido'
      if (this.isManualDrop && !field.minValue) return 'Debe ser mayor a 0'
      return 'Cantidad inválida'
    },
    getQuantityClass(existing, toReduce) {
      const result = existing - toReduce
      if (result < 0) return 'text-danger'
      if (result === 0) return 'text-warning'
      return 'text-primary'
    },
    handleAddRow() {
      this.tableItems.push({
        id: null,
        part_number: null,
        quantity: null,
        real_location: '',
        description: '',
        tipo: this.normalizedType,
      })
    },
    handleInput(index, value) {
      this.index = index
      this.search = value
    },
    handleDeleteRow(index) {
      this.tableItems.splice(index, 1)
    },
    handleHit(value, index) {
      this.tableItems[index].id = value.id
      this.tableItems[index].part_number = value.part_number
      this.tableItems[index].real_location = value.real_location
      this.tableItems[index].description = value.description
      this.tableItems[index].cantidad_drop = value.cantidad_drop
      this.tableItems[index].cantidad_malos = value.cantidad_malos
      this.tableItems[index].cantidad_buenos = value.cantidad_buenos
      this.search = ''
    },
    handleDeleteAll() {
      this.tableItems = []
    },
    handleSaveClick() {
      if (this.tableItems.filter((ti) => ti?.id === null).length > 0) {
        this.$bvToast.toast('Algunas de las piezas especificadas no existe', {
          variant: 'danger',
        })
      }
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else if (this.isRebaja) {
        this.$bvModal.show('confirmation-modal')
      } else {
        this.executeSave()
      }
    },
    async executeSave() {
      this.$bvModal.hide('confirmation-modal')
      this.loading = true
      // Validation passed in handleSaveClick
      let itemsToSave = this.tableItems
      if (this.isRebaja) {
        itemsToSave = this.tableItems.filter((item) => {
          const qty =
            item.quantity === '' || item.quantity === null
              ? 0
              : parseInt(item.quantity, 10)
          return qty > 0
        })
      }
      const res = await this.saveInventory(itemsToSave)
      if (res.status === 200) {
        this.$bvToast.toast('Inventario ingresado exitosamente', {
          variant: 'success',
        })
        setTimeout(
          () => this.$router.push({ name: 'Control de Inventario' }),
          1000
        )
      } else {
        const responseMsj = res.data.substring(
          res.data.indexOf("'") + 1,
          res.data.indexOf("'", res.data.indexOf("'") + 1)
        )
        this.$bvToast.toast(responseMsj, {
          variant: 'danger',
        })
      }
      this.loading = false
    },
    async handleFileUpload() {
      this.loading = true;
      const file_data = new FormData()
      file_data.append('file', this.file)
      file_data.append('tipo_movimiento', this.normalizedType)
      const response = await this.saveInventoryExcel(file_data)
      console.log(response)
      if (response.status === 200) {
        console.log(response.data)
        this.$bvToast.toast('Inventario ingresado.', {
          variant: 'success',
        })
        setTimeout(
          () => this.$router.push({ name: 'Control de Inventario' }),
          1000
        )
      } else {
        const responseMsj = response.data.substring(
          response.data.indexOf("'") + 1,
          response.data.indexOf("'", response.data.indexOf("'") + 1)
        )
        this.$bvToast.toast(responseMsj, {
          variant: 'danger',
        })
      }
      this.loading = false;
    },
    async setDefault(state) {
      this.loading = true;
      await this.searchPartsByState({ state })
      this.index = 0
      this.filteredParts.forEach((part) => {
        this.handleAddRow()
        this.handleHit(part, this.index)
        this.index += 1
      })
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters('Diagnosticos', ['filteredParts']),
    isRebaja() {
      return ['drop', 'scrap', 'rtv'].includes(this.$route.params.tipo)
    },
    computedFields() {
      if (this.isRebaja && !this.isManualDrop) {
        return this.fields.filter((f) => f.key !== 'delete')
      }
      return this.fields
    },
    summaryItems() {
      if (!this.isRebaja) return []
      return this.tableItems
        .filter((item) => {
          const qty =
            item.quantity === '' || item.quantity === null
              ? 0
              : parseInt(item.quantity, 10)
          return qty >= 1
        })
        .map((item) => ({
          part_number: item.part_number,
          existingQuantity: item[this.existingQuantityAttribute],
          quantity: item.quantity,
        }))
    },
    confirmationTitle() {
      return `Confirmar ${this.title}`
    },
    title() {
      const titulo = this.$route.params.tipo
      if (titulo === 'drop') {
        return 'Rebaja de DROP'
      }
      if (titulo === 'scrap' || titulo === 'scrap-bad' || titulo === 'scrap-good') {
        return 'Scrap'
      }
      if (titulo === 'rtv') {
        return 'RTV'
      }
      if (titulo === 'slow') {
        return 'SLOW'
      }
      return 'Ingreso de Inventario'
    },
    existingQuantityAttribute() {
      const titulo = this.$route.params.tipo
      if (titulo === 'drop') {
        return 'cantidad_drop'
      }
      if (titulo === 'rtv' || titulo === 'scrap-bad') {
        return 'cantidad_malos'
      }
      if (titulo === 'slow' || titulo === 'scrap-good') {
        return 'cantidad_buenos'
      }
      return 'cantidad_buenos'
    },
    normalizedType() {
      const titulo = this.$route.params.tipo
      if (titulo === 'scrap-bad') {
        return 'scrap'
      }
      if (titulo === 'scrap-good') {
        return 'scrap_good'
      }
      return titulo
    },
    isManualDrop() {
      return this.$route.params.tipo === 'drop'
    },
  },
  watch: {
    async search(value) {
      if (value.length > 2) {
        const { data } = await this.searchByPartNumber({
          partNumber: value,
        })
        console.log(data.results)
        if (this.isManualDrop) {
          this.data = data.results.filter((i) => i.cantidad_drop >= 1)
        } else {
          this.data = data.results
        }
      }
    },
  },
  created() {
    const titulo = this.$route.params.tipo
    if (titulo === 'rtv') {
      const state = 'bad'
      this.setDefault(state)
    } else {
      // Para otros tipos, agregar al menos una fila vacía
      this.handleAddRow()
    }
  },
}
</script>
<style lang="scss" scoped>
.title {
  color: #74788d;
  font-weight: bold;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

#confirmation-modal {
  ::v-deep .modal-title {
    padding-left: 0.5rem;
  }
  
  .confirmation-content {
    padding: 1rem 1.5rem;
  }
  
  .table thead th {
    background-color: transparent;
    border-top: none;
    border-bottom: none;
    white-space: nowrap;
    padding: 0.1rem 0.75rem 0.5rem 0.75rem;
    line-height: 1;
  }
  
  .table tbody td {
    border-top: none;
    padding: 0.5rem 0.75rem;
  }
  
  .table {
    border: none;
  }
}
</style>
